<script>
    
    import DatasetSummary from "../Dashboard/dataset-summary.svelte";
    import LJPSample from "./ljp-sample.svelte";
    import LJPDescription from "./ljp-description.svelte";
    import LJPDataField from "./ljp-datafield.svelte";
    import LJPDataSplit from "./ljp-datasplit.svelte";
    import MoreInfo from "./more-information.svelte";
    import {
    Container,
    Row,
    Col,
    Button,
    Card,
    CardBody,
    CardTitle,
    Modal,
    Input,
  } from "sveltestrap";
  </script>
  
  <div class="page-content">
    <Container fluid>
      <!-- <Breadcrumbs title="홈" breadcrumbItem="Dashboard" /> -->
      <Row>
        <Col lg="12">
          <LJPDescription />
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <LJPSample />
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <LJPDataField />
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <LJPDataSplit />
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <MoreInfo />
        </Col>
      </Row>
      
      
    </Container>
  </div>
  